import {useEffect, useRef} from "react";
import Styles from "./ScanningDisplay.module.scss"
import type {LogMessage} from "../util/ctx/useScanMessages.tsx";

interface Props {
    messages: LogMessage[]
}
export function ScanningLog({messages}: Props) {
    const finalRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        finalRef.current?.scrollIntoView({behavior: "smooth"})
    })
    return <pre className={Styles.Log}>
        {messages.map((message) => `${message.timestamp.toLocaleTimeString()} - [${message.level}] - ${message.message}`).join("\n")}
        <div ref={finalRef} />
    </pre>
}